<template>
  <div class="opple-ability-ui-form">
    <slot />
  </div>
</template>

<script>
import ImageEnumType from './components/ImageEnumType.vue'; // 导入组件A
import TimeRangeType from './components/TimeRangeType.vue'; // 导入组件B

export default {
  comments: {
    ImageEnumType,
    TimeRangeType
  },
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },

  methods: {
    getSlotChildren() {
      const soltList = this.$slots.default || [];
      const solt = soltList[0]

      if (!solt) return {};

      const abilityComList = [];
      

      this.loopChildrenGetAbilityUiCom(solt, abilityComList);

      return abilityComList;
    },
    // 获取值
    getFormData() {
      const abilityComList = this.getSlotChildren();
      const abilityComDataList = [];

      abilityComList.forEach(vnode => {
        if (
          vnode.componentInstance &&
          vnode.componentInstance.getData instanceof Function
        ) {
          const data = vnode.componentInstance.getData();

          if (data && !!Object.keys(data).length) {
            abilityComDataList.push(
              data
            )
          }
        }        
      })

      return abilityComDataList;
    },
    // 校验逻辑
    validateForm() {
      const abilityComList = this.getSlotChildren();
      let result = {
        status: true
      }
      for (let i = 0; i < abilityComList.length; i++) {
        const vnode = abilityComList[i];

        if (
          vnode.componentInstance &&
          vnode.componentInstance.validate instanceof Function
        ) {
          const valiInfo = vnode.componentInstance.validate();

          if (!valiInfo.status) {
            result = valiInfo;
            break;
          }
        }
      }

      return result;
    },

    onSave() {
      const abilityComList = this.getSlotChildren();
      for (let i = 0; i < abilityComList.length; i++) {
        const vnode = abilityComList[i];

        if (
          vnode.componentInstance &&
          vnode.componentInstance.onSave instanceof Function
        ) {
          vnode.componentInstance.onSave();
        }
      }
    },

    /**
     * 手机所有opple-ability-com的数据
     * @param {*} vNode 
     * @param {*} abilityComList 
     */
    loopChildrenGetAbilityUiCom(vNode, abilityComList) {
      if (
        vNode.componentOptions &&
        vNode.componentOptions.tag === 'opple-ability-com'
      ) {
        abilityComList.push(vNode);
      }

      const children = vNode.children;

      if (children && children.length) {
        children.forEach(child => {
          this.loopChildrenGetAbilityUiCom(child, abilityComList);
        });
      }
    }
  },
};
</script>

<style lang="scss">


</style>